// Show the given element
window.showVbError = (errorElement) => {
    errorElement?.classList.add("vb_error__container_visible");
}

// Hide the given element
window.hideVbError = (errorElement) => {
    errorElement?.classList.remove("vb_error__container_visible");
}

// Returns true if there are any visible VB errors on the page
window.checkForVbErrors = () => {
    const pageErrors = document.querySelectorAll(".vb_error__container_visible");
    return pageErrors.length > 0;
}

// Disable the specified button if any VB errors are present
window.toggleVbButton = (button) => {
    if (window.checkForVbErrors()) {
        button.classList.add("disabled");
        button.setAttribute("disabled", "disabled");
    } else {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
    }
}
